/**
 * Cambodian riel.
 */
export var KHR = {
  code: 'KHR',
  base: 10,
  exponent: 2
};